module.exports = __webpack_public_path__ + "img/art_5_2.72d758c2.jpeg";